import { useCallback, useEffect, useState } from 'react';
import { Cashier } from '../types/cashier.types';
import { listAvailableCashiers } from '../services/AuthService';

export const useAvailableCashiers = (enabled: boolean) => {
    const [cashiers, setCashiers] = useState<Cashier[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const load = useCallback(() => {
        setIsLoading(true);
        setError(null);
        listAvailableCashiers()
            .then((list) => {
                setCashiers(list);
                setIsLoading(false);
            })
            .catch((err) => {
                setCashiers([]);
                setError(err?.message || 'No se pudo cargar la lista de cajeros.');
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!enabled) return;
        load();
    }, [enabled, load]);

    return { cashiers, isLoading, error, reload: load };
};
